/* eslint-disable react-hooks/exhaustive-deps */
import { each, get, isArray, } from "lodash-es";
import React, { useEffect, useState } from "react";
import Form from "../Form";
import Modal, { ModalHeader, ModalTab } from "../Modal";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import { ISKOREA_LIST, LOCAL_LIST, OFFICE_LIST, SEX_LIST } from "../../constants/EMPLOYEE";
import { getKoicaNationalCodes } from "../../apis/code";
import { approveEmployeeRequest, createEmployee, deleteEmployee, modifyMyEmployeeProfile, putEmployee } from "../../apis/employee/employee";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { employeeDetailView, getEmployeeForm } from "../../utils/employee";
import { getStoreEmployees, setProfile } from "../../store/actions";
import Button from "../Button";
import EmployeeBankAccounts from "./EmployeeBankAccounts";
import EmployeeFamilyList from "./EmployeeFamilyList";
import { isEmpty } from "../../utils/lodashExtend";
import { ROLE_RANGE_LIST } from "../../constants/ROLE";
import emptyUserImage from "../../assets/images/empty-user-img.png";
// import { dateToViewFormat } from "../../utils/date";
import { fileUpload } from "../../utils/file";
import { isEqual } from "lodash";
import { toast } from "../../utils/toast";
import EmployeeSigns from "./EmployeeSigns";

// import useForm from "../../hooks/useForm";

const EmployeeDetail = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [submit, setSubmit] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [fields, setFields] = useState([]);
  const [isMe, setIsMe] = useState(false);
  const [tabList, setTabList] = useState([]);
  const [profileImgInfo, setProfileImgInfo] = useState({});
  const [mode, setMode] = useState('detail');
  const [targetPermission, setTargetPermission] = useState(null);

  const dispatch = useDispatch();
  const { employeeDetail, employee: myEmployee, permissions } = useSelector(
    (store) => ({
      employeeDetail: store.Employee.employeeDetail,
      employee: store.Profile.employee,
      permissions: store.Profile.permissions,
    }),
    shallowEqual
  );

  const reloadMyInfo = () => {
    dispatch(setProfile());
  };

  const reloadEmployeeList = () => {
    setTimeout(() => {
      dispatch(getStoreEmployees());
    }, 500);
  };

  useEffect(() => {
    if (!isEmpty(permissions)) {
      setTargetPermission(permissions.find(p => p.code === 'USER'));
    }
  }, [permissions]);

  useEffect(() => {

    const isRead = isMe || (targetPermission && targetPermission.level > 1);
    setTabList([
      { label: "기본정보", action: setActiveTab },
      { label: "부가정보", action: setActiveTab },
      ...isRead ? [{ label: "급여계좌", action: setActiveTab }] : [],
      ...isRead ? [{ label: "가족", action: setActiveTab }] : [],
      ...isRead ? [{ label: "서명", action: setActiveTab }] : [],
    ]);
  }, [isMe, targetPermission]);

  useEffect(() => {
    !isEmpty(targetPermission) &&
      _setField();
  }, [activeTab, targetPermission]);


  useEffect(() => {

    if (employeeDetail) {
      const { options, mode, ...employee } = employeeDetail || {};
      const _selectedUser = selectedUser || {};
      setValidateFields(fields);
      setMode(mode);
      if (!isEmpty(employee)) {
        setForm(getEmployeeForm(employee));
        setOriginForm(getEmployeeForm(employee));
        setIsMe(myEmployee.idx === employeeDetail.idx);
      } else {
        setForm(getEmployeeForm(_selectedUser));
        setOriginForm(getEmployeeForm(_selectedUser));
      }
      if (employeeDetail.options) {
        setSelectedUser(employeeDetail.options.selectedUser);
        setSubmit(() => employeeDetail.options.submit);
      }
    }

  }, [selectedUser, employeeDetail, myEmployee]);

  const _setField = async () => {
    const nationalCodesRespone = await getKoicaNationalCodes();
    const nationalCodes = get(nationalCodesRespone, 'data.koicaNationalCodes', []);
    setFields([
      {
        isHide: () => activeTab !== 0,
        type: 'line'
      },
      [
        {
          isHide: () => activeTab !== 0,
          title: "직원이름", key: "name", type: targetPermission.level > 1 ? "input" : "text", required: true,
        },
        {
          isHide: () => activeTab !== 0,
          title: "직원코드", key: "code", type: targetPermission.level > 1 ? "input" : "text", required: true,
          validators: ['number']
        },
        {
          isHide: () => activeTab !== 0,
          title: "타솔루션코드", key: "otherCode", type: targetPermission.level > 1 ? "input" : "text",
          placeholder: '더존,세무사랑 등',
        },
      ],
      [
        {
          isHide: () => activeTab !== 0,
          title: "성별",
          key: "sex",
          ...(targetPermission.level > 1 ? {
            type: "radio",
            options: {
              list: SEX_LIST,
            },
            required: true,
          } : {
            onValue: (v) => SEX_LIST.find(f => f.value === v)?.label
          })
        },
        {
          isHide: () => activeTab !== 0,
          title: <>주민등록번호<br />/외국인번호</>, key: "juminNum", type: targetPermission.level > 1 ? "input" : "text",
          titlestyle: {
            lineHeight: "16px"
          },
          placeholder: '주민등록번호 / 외국인등록번호',
          validators: ['jumin']
        },
      ],


      [
        {
          isHide: () => activeTab !== 0,
          title: "핸드폰", key: "mobile", type: targetPermission.level > 1 ? "input" : "text",
          validators: ['mobile']
        },
        {
          isHide: () => activeTab !== 0,
          title: "전화번호", key: "phone", type: targetPermission.level > 1 ? "input" : "text",
        },
      ],

      [
        {
          isHide: () => activeTab !== 0,
          title: "이메일",
          key: "email",
          type: targetPermission.level > 1 ? "input" : "text",
          validators: ['email']
        },

        {
          isHide: () => activeTab !== 0,
          title: "사람접근범위",
          key: "roleRange",
          ...(targetPermission.level > 1 ? {
            type: 'select',
            required: true,
            options: {
              list: ROLE_RANGE_LIST
            }
          } : {
            onValue: (v) => ROLE_RANGE_LIST.find(f => f.value === v)?.label
          })
        },
      ],
      [
        {
          isHide: () => activeTab !== 0,
          title: "주소",
          key: "",
          ...(targetPermission.level > 1 ? {
            options: {
              addressDetailKey: 'addr2',
              addressKey: 'addr1',
              zipCodeKey: 'addrCode',
            },
            type: "address",
            className: 'full'
          } : {
            key: "addr1",
            onValue: (_, __, d) =>
              (d?.addr1 || d?.addr2) && `${d?.addr1 || ""} ${d?.addr2 || ""}`
          })
        },
      ],
      [
        {
          isHide: () => activeTab !== 0,
          title: "재직여부",
          key: "office",
          ...(targetPermission.level > 1 ? {
            type: "radio",
            options: {
              list: OFFICE_LIST,
            },
            required: true
          } : {
            onValue: (v) => OFFICE_LIST.find(f => f.value === v)?.label
          })
        },
      ],

      [
        {
          isHide: () => activeTab !== 0,
          title: "입사일",
          key: "joinDate",
          type: targetPermission.level > 1 ? "datepicker" : "text",
          required: true
        },
        {
          isHide: () => activeTab !== 0,
          title: "퇴사일",
          key: "leaveDate",
          tooltip: "재직여부와 관계없이, 지정하시게 되면 접근이 불가합니다.\n 퇴사 후 재입사 등 퇴사일 삭제가 필요한 경우 관리자에게 문의 바랍니다.",
          type: targetPermission.level > 1 ? "datepicker" : "text",
        },
      ],

      [
        {
          isHide: () => activeTab !== 1,
          title: "내/외국인",
          key: "local",
          type: "radio",
          options: {
            list: LOCAL_LIST,
          },
          required: true
        },
        {
          isHide: () => activeTab !== 1,
          title: "거주 국가",
          key: "isKorea",
          type: "radio",
          options: {
            list: ISKOREA_LIST,
          },
          required: true
        },
      ],
      {
        isHide: () => activeTab !== 1,
        title: "국적 국가",
        type: "search-select",
        className: "manager-form-search-select",
        options: {
          list: nationalCodes.map(nationalCodeData => ({
            ...nationalCodeData,
            label: nationalCodeData.code + " - " + nationalCodeData.name,
            value: nationalCodeData.code
          })),
          menuPlacement: "top",
        },
        onChange: (data) => {

          setForm({
            ...form,
            nationalName: data.name,
            nationalCode: data.code,
          });
        },
      },
      [
        {
          isHide: () => activeTab !== 1,
          title: "국가명",
          key: "nationalName",
          type: "text",
        },
        {
          isHide: () => activeTab !== 1,
          title: "국가코드",
          key: "nationalCode",
          type: "text",
        },
      ]

      // {
      //   isHide: () => activeTab !== 1,
      //   title: "거주 국가",
      //   type: "search-select",
      //   className: "manager-form-search-select",
      //   options: {
      //     list: nationalCodes.map(nationalCodeData => ({
      //       ...nationalCodeData,
      //       label: nationalCodeData.code + " - " + nationalCodeData.name,
      //       value: nationalCodeData.code
      //     })),
      //     menuPlacement: "top",
      //   },
      //   onChange: (data) => {
      //     setForm({
      //       ...form,
      //       countryName: data.name,
      //       countryCode: data.code,
      //     });
      //   },
      // },
      // [
      //   {
      //     isHide: () => activeTab !== 1,
      //     title: "거주 국가명",
      //     key: "countryName",
      //     type: "text",
      //   },
      //   {
      //     isHide: () => activeTab !== 1,
      //     title: "거주 국가코드",
      //     key: "countryCode",
      //     type: "text",
      //   },
      // ],

      // [
      //   {
      //     isHide: () => activeTab !== 0, // 직급
      //     title: "gradeIdx",
      //     key: "gradeIdx",
      //     type: "input",
      //   },
      // ],

    ]);
  };

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }

    setActiveTab(0);
    employeeDetailView(null);
  };


  const getParams = (form) => {
    const params = {};
    each(form, (value, key) => {
      if (!isEmpty(value)) {
        if (isArray(value)) {
          params[key] = value[0];
        } else {
          params[key] = value;
        }
      } else {
        if (mode !== 'create') {
          params[key] = null;
        }
      }
    });

    return {
      ...params,
    };

  };
  const _submit = async ({ idx, profileImg, ...form }) => {
    if (mode === 'create') {
      systemAlert(`"${form.name}"님을 등록하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              createEmployee({ ...getParams(form), isTax: employeeDetail?.options?.isTax })
                .then(async (res) => {
                  const { employeeIdx } = res.data;
                  await approveEmployeeRequest({
                    name: form.name,
                    idx: selectedUser.idx
                  }, employeeIdx, employeeDetail?.options?.isTax);
                  cancel();
                  if (submit) {
                    submit();
                  }
                  reloadEmployeeList();
                });
            }
          }
        ]
      });
    } else {
      if (!isEqual(profileImg, originForm.profileImg)) {
        form = {
          ...form,
          profileIdx: profileImgInfo.fileIdx
        };
      }

      systemAlert(`"${form.name}"님를 수정하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '수정',
            onClick: () => {

              putEmployee(employeeDetail.idx, { ...getParams(form), isTax: employeeDetail?.options?.isTax })
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }
                  if (isMe) {
                    reloadMyInfo();
                  }
                  reloadEmployeeList();
                });
            }
          }
        ]
      });
    }
  };




  // 삭제 추구 추가 
  const _delete = async () => {
    systemAlert(`"${employeeDetail.name}"님을 삭제하시겠습니까?\n 
    삭제 후 확인 할 수 없는 데이터가 있습니다.\n
    삭제된 데이터는 복구할 수 없습니다.`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '승인',
          onClick: () => {

            deleteEmployee(employeeDetail.idx, { isTax: employeeDetail?.options?.isTax })
              .then(async (res) => {
                systemAlert(`"${employeeDetail.name}"님이 삭제되었습니다.`, {
                  buttons: [
                    {
                      label: '확인',
                      onClick: () => {
                        window.location.reload();
                      }
                    }
                  ]
                });

              });
          }
        }
      ]
    });
  };

  const {
    form,
    errors,
    originForm,
    handleSubmit,
    handleOnChange,
    setForm,
    setOriginForm,
    setValidateFields
  } = useForm(
    getEmployeeForm(),
    _submit,
  );

  useEffect(() => {
    if (!isEmpty(profileImgInfo)) {
      setForm({
        ...form,
        profileImg: profileImgInfo.fileUrl
      });
    }
  }, [profileImgInfo]);

  const uploadProfileImg = async (e) => {
    const file = e.target.files[0];
    try {
      const _files = await fileUpload(file, true);
      setProfileImgInfo(_files);

      if (isMe) {
        systemAlert(`프로필 사진을 변경하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                modifyMyEmployeeProfile(myEmployee.idx, { profileIdx: _files.fileIdx })
                  .then(() => {
                    toast.success('프로필 사진 변경에 성공했습니다.');
                  })
                  .catch(() => { })
                  .finally(() => { });
              }
            }
          ]
        });
      }
    } catch (e) { }
  };

  return (
    <Modal
      isOpen={!!employeeDetail}
      // isOpen={true}
      close={cancel}
    // {...mode === 'create' ? { close: cancel } : { toggle: cancel }}
    >
      <div className="employee-detail-modal">
        {/* {JSON.stringify(employeeDetail)} */}
        <ModalHeader>직원 {targetPermission?.level > 1 ? mode === 'create' ? '등록' : '수정' : '정보 확인'}</ModalHeader>
        <ModalTab tabList={tabList} active={activeTab} />
        {activeTab === 0 && (
          <div className="employee-info-summary-container">
            <div className="employee-name-container">
              <label className="profile-image-wrap">
                <input type="file" name="profile-image" accept="image/*" onChange={uploadProfileImg} />
                <img src={form.profileImg || emptyUserImage} alt={form.name || 'employee'} />
              </label>
              <div className="user-name-wrap">
                <p className="user-name">{get(form, 'name')}</p>
              </div>
            </div>
            <div className="employee-info-summary-table">
              <table>
                <tbody>
                  <tr>
                    <td className="title">근무구분</td>
                    <td className="content">
                      <p>{get(form, 'office') === "1" ? '근무중' : '퇴사'}</p>
                    </td>
                    <td className="title">부서</td>
                    <td className="content">
                      <p>{get(employeeDetail, 'partName')}</p>
                    </td>
                  </tr>
                  <tr>
                    <td className="title">직원코드</td>
                    <td className="content">
                      <p>{get(form, 'code')}</p>
                    </td>
                    <td className="title">입사일</td>
                    <td className="content">
                      <p>
                        {get(form, 'joinDate')}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
        {
          activeTab < 2 &&
          <Form
            mode={mode}
            form={form}
            errors={errors}
            isRequiredShow={true}
            setForm={setForm}
            fields={fields}
            onChange={handleOnChange}
            buttons={
              !isEmpty(targetPermission) && targetPermission.level > 1 ? [
                {
                  label: '삭제',
                  color: 'danger',
                  className: 'float-left',
                  onClick: _delete
                },
                {
                  label: '취소',
                  color: 'text',
                  onClick: cancel
                },
                {
                  label: mode === 'create' ? '등록' : '수정',
                  onClick: handleSubmit
                },
              ] : [{
                label: '닫기',
                color: 'text',
                onClick: cancel
              },]
            }
          // submitText={mode === 'create' ? '등록' : '수정'}
          // submit={handleSubmit}
          // cancel={cancel}
          />
        }
        {
          // 급여 계좌 관리
          activeTab === 2 && (
            <EmployeeBankAccounts
              employee={employeeDetail}
            />
          )
        }
        {
          // 가족 관리
          activeTab === 3 && (
            <EmployeeFamilyList
              employee={employeeDetail}
            />
          )
        }

        {
          // 서명 관리
          activeTab === 4 && (
            <EmployeeSigns
              employee={employeeDetail}
            />
          )
        }
        {
          activeTab >= 2 && <div className="form-button-wrap text-align-right">
            <Button
              color="text"
              onClick={cancel}
            >
              닫기
            </Button>
          </div>
        }
      </div>
    </Modal>
  );
};

export default EmployeeDetail;
